// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"81cea70f","453":"a00f74c9","455":"0a4a3084","977":"15dede35"}[chunkId] + ".chunk.js";
};